import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { DatePipe } from '@angular/common';
import { InspectionStorageService } from 'src/app/modules/course-accreditation/services/inspection-storage.service';
import { StpRegistrationRenewReapplyService } from '../../../services/stp-registration-renew-reapply.service';

@Component({
  selector: 'app-result-scrutiny',
  templateUrl: './result-scrutiny.component.html',
  styleUrls: ['./result-scrutiny.component.scss'],
})
export class ResultScrutinyComponent implements OnInit {
  scrutinyReportInfo: any;
  detailsInspectionReportList: any;
  inspectionId: number;
  stpMainId: number;
  nsdaOfficerName: string;
  designation: string;
  rollbackRemarks: FormControl = new FormControl('');

  // for pagination
  total: number;
  size: number = 10;
  page: number = 1;
  sortingKey: string;
  sortingValue: string;
  value: any = null;

  scrutinyBtnDisable = false;
  rollbackBtnDisable = false;
  isRollbackRemarks = false;

  isRenewalApplication: boolean = false;

  applicationId:string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private inspectionStorageService: InspectionStorageService,
    private notification: NzNotificationService,
    private stpRegistrationRenewReapplyService: StpRegistrationRenewReapplyService,
    public datepipe: DatePipe,
  ) {}

  ngOnInit() {
    this.inspectionId = this.route.snapshot.params.inspectionId;
    const type = this.route.snapshot.paramMap.get('type');
    if (type === 'renewal') {
      this.isRenewalApplication = true;
    } else {
      this.isRenewalApplication = false;
    }
    this.getInspectionScrutinyResult();
  }

  getInspectionScrutinyResult() {
    this.stpRegistrationRenewReapplyService
      .readResultScrutinyInfoByInspectionId(this.inspectionId)
      .subscribe(
        (res) => {
          this.scrutinyReportInfo = res['data'];

          this.scrutinyReportInfo.applicationDate = this.datepipe.transform(
            this.scrutinyReportInfo?.applicationDate?.substring(0, 10),
            'dd-MM-yyyy',
          );
          this.scrutinyReportInfo.inspectionConductedDate =
            this.datepipe.transform(
              this.scrutinyReportInfo?.inspectionConductedDate?.substring(
                0,
                10,
              ),
              'dd-MM-yyyy',
            );
          this.stpMainId = res.data.stpId;
          this.applicationId = res.data?.applicationId;
          let nsdaOfficerId = res.data?.nsdaOfficer;
          if (nsdaOfficerId != null) {
            this.getNsdaOfficer(nsdaOfficerId);
          }
          this.detailsInspectionReportList =
            this.scrutinyReportInfo[
              'inspectionReportsRecommendationDetailsReportPayload'
            ];
          this.detailsInspectionReportList.forEach(
            (item: any, index: number) => {
              if (item.inspectionRegistrationReportId != null) {
                item['type'] = 'STP';
              } else item['type'] = 'Occupation';
            },
          );
        },
        (error) => {
          this.notification.error(
            'Error!',
            'Error getting scrutiny inspection result info',
          );
        },
      );
  }

  getNsdaOfficer(officer_id: number) {
    this.inspectionStorageService
      .getUserByUserId(officer_id)
      .subscribe((res) => {
        this.nsdaOfficerName = res?.name;
        this.designation = res?.designation;
      });
  }

  onScrutinyResultSubmit() {
    this.scrutinyBtnDisable = true;
    this.stpRegistrationRenewReapplyService
      .submitResultScrutiny(this.inspectionId)
      .subscribe(
        (res) => {
          if (res['success']) {
            this.notification.success(
              'Success!',
              'Result Scrutiny Inspection Information saved successfully',
            );
            const path = this.isRenewalApplication
              ? '/home/stp-registration/stp-renewal-application-list'
              : '/home/stp-registration/stp-reapply-application-list';

            this.router.navigate([path]);
          } else {
            this.notification.error('Error!', res['message']);
            this.scrutinyBtnDisable = false;
          }
        },
        (error) => {
          this.notification.error(
            'Error!',
            'Error Saving scrutiny inspection result',
          );
          this.scrutinyBtnDisable = false;
        },
      );
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.page = params.pageIndex;
    this.size = params.pageSize;
    params.sort.forEach((element: { value: string | null; key: string }) => {
      if (element.value != null) {
        this.sortingKey = element.key;
        this.sortingValue = element.value;
      }
    });
  }

  onEditStpSac(inspectionId: number): void {
    this.router.navigate(
      [
        `home/stp-registration/stp-sac-inspection-report-preview-renew-reapply/${inspectionId}`,
      ],
      {
        queryParams: {
          type: 'edit',
        },
      },
    );
  }

  onViewStpSac(inspectionId: number): void {
    this.router.navigate(
      [
        `home/stp-registration/stp-sac-inspection-report-preview-renew-reapply/${inspectionId}`,
      ],
      {
        queryParams: {
          type: 'view',
        },
      },
    );
  }

  onScrutinyResultRollBack() {
    const remarks = this.rollbackRemarks.value?.trim();

    if (!remarks) {
      this.isRollbackRemarks = true;
      this.notification.warning(
        'Warning!',
        'Please input rollback remarks first !',
      );
      return;
    }

    this.rollbackBtnDisable = true;
    this.stpRegistrationRenewReapplyService
      .rollbackStpFromResultScrutiny(this.inspectionId, remarks)
      .subscribe(
        (res) => {
          if (res['success']) {
            this.notification.success(
              'Success!',
              'Rollback Scrutiny Inspection Result Information successfully',
            );
            const path = this.isRenewalApplication
              ? '/home/stp-registration/stp-renewal-application-list'
              : '/home/stp-registration/stp-reapply-application-list';

            this.router.navigate([path]);
          } else {
            this.notification.error('Error!', res['message']);
            this.rollbackBtnDisable = false;
          }
        },
        (error) => {
          this.notification.error(
            'Error!',
            'Error Rollback scrutiny inspection result',
          );
          this.rollbackBtnDisable = false;
        },
      );
  }

  showRollbackRemarks() {
    this.isRollbackRemarks = true;
  }
}
